export const columns = [
  { name: 'checkbox', label: '', width: 50, textAlign: 'left' },
  { name: 'document_id', label: 'Document ID', width: 100, textAlign: 'left' },
  { name: 'result', label: 'Result', width: 200, textAlign: 'center' },
  { name: 'document_type', label: 'Document Type', width: 220, textAlign: 'center' },
  { name: 'actions', label: 'Actions', width: 150, textAlign: 'right' }
];
